/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ClusterFrequencyTimeDetails {
    getFixupPrototypeFunction() { return ClusterFrequencyTimeDetails.fixupPrototype; }

    static newInstance(model: Partial<ClusterFrequencyTimeDetails>): ClusterFrequencyTimeDetails {
        let obj = Object.assign(new ClusterFrequencyTimeDetails(), model);
        ClusterFrequencyTimeDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ClusterFrequencyTimeDetails>): ClusterFrequencyTimeDetails {
        if (!model) return null;
        return ClusterFrequencyTimeDetails.newInstance(<ClusterFrequencyTimeDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ClusterFrequencyTimeDetails) {
        if (!obj) return;

        models.ClusterFrequencyTimeDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ClusterFrequencyTimeDetails): boolean {
        Object.setPrototypeOf(obj, ClusterFrequencyTimeDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cost Resolution Frequency Day
     */
    day: string;

    /**
     * Cost Resolution Frequency Hour
     */
    hour: string;

    /**
     * Cost Resolution Frequency Minute
     */
    minute: string;

}
